namespace GeniuzPOS.Administration {
    export interface PsPosFuncRow {
        Id?: number;
        FuncId?: string;
        FuncDesc?: string;
        FunLevel?: number;
        FuncUsage?: number;
        KbMapShiftCode?: number;
        KbMapKeyCode?: number;
        FuncKeyLable?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        RowNumber?: number;
    }

    export namespace PsPosFuncRow {
        export const idProperty = 'Id';
        export const nameProperty = 'FuncId';
        export const localTextPrefix = 'Administration.PsPosFunc';
        export const lookupKey = 'Administration.PsPosFunc';

        export function getLookup(): Q.Lookup<PsPosFuncRow> {
            return Q.getLookup<PsPosFuncRow>('Administration.PsPosFunc');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';

        export declare const enum Fields {
            Id = "Id",
            FuncId = "FuncId",
            FuncDesc = "FuncDesc",
            FunLevel = "FunLevel",
            FuncUsage = "FuncUsage",
            KbMapShiftCode = "KbMapShiftCode",
            KbMapKeyCode = "KbMapKeyCode",
            FuncKeyLable = "FuncKeyLable",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            RowNumber = "RowNumber"
        }
    }
}
